var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaticon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H31.9956C40.8322 0 47.9956 7.16344 47.9956 16V31.9956C47.9956 40.8322 40.8322 47.9956 31.9956 47.9956H16C7.16344 47.9956 0 40.8322 0 31.9956V16Z",
    fill: "#2F91F8",
    fillOpacity: 0.14
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9932 13.9988V17.9988",
    stroke: "#2F91F8",
    strokeWidth: 1.99982,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9927 13.9988V17.9988",
    stroke: "#2F91F8",
    strokeWidth: 1.99982,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9922 15.9985H16.9935C15.889 15.9985 14.9937 16.8939 14.9937 17.9984V31.9971C14.9937 33.1015 15.889 33.9969 16.9935 33.9969H30.9922C32.0967 33.9969 32.992 33.1015 32.992 31.9971V17.9984C32.992 16.8939 32.0967 15.9985 30.9922 15.9985Z",
    stroke: "#2F91F8",
    strokeWidth: 1.99982,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9937 21.998H32.992",
    stroke: "#2F91F8",
    strokeWidth: 1.99982,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaticon01);
export default __webpack_public_path__ + "static/media/staticon01.c393dc6df4ce76432911a997d87424b5.svg";
export { ForwardRef as ReactComponent };